//  Every path in the app, in one place. Five call sites have to agree on these strings:
//  the route table, the nav, the brand, the post-invite redirect, and the login `from`
//  default.
export const paths = {
  inviteMerchant: "/invite-merchant",
  inviteHistory: "/invite-history",
  merchants: "/merchants",
  merchantReport: "/merchant-report",
  login: "/login",
  healthz: "/healthz",
};

//  Where "/" lands, where the brand points, and where login sends a user who arrived
//  without a `from`.
export const defaultPath = paths.merchants;
